module.exports = __webpack_public_path__ + "static/img/gjf-gaj.7c0e9bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gjf-gaj.jpg
// module id = i3ah
// module chunks = 1